import React, { useState,useEffect } from "react";
import { Card, CardBody, Row, Col, Input, Button, Label } from "reactstrap";
import axiosConfig from "../../AxiosConfig";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";



export default function AddCategory() {
  const location = useLocation();
const editData = location.state?.data;
const navigate = useNavigate();

const isEdit = !!editData;

  const [form, setForm] = useState({
    name: "",
    desc: "",
    status: "Active",
    selectedName: "",
  });
useEffect(() => {
  if (editData) {
    setForm({
      name: editData.name || "",
      desc: editData.description || editData.desc || "",
      status: editData.status || "Active",
      selectedName: "",
      steps: editData.steps || [],
    });
  }
}, [editData]);
  // 🔄 handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };



  // 🚀 submit
  // const submitHandler = async (e) => {
  //   e.preventDefault();

  //   try {
  //     let pageparmission = JSON.parse(localStorage.getItem("userData"));

  //     const data = {
  //       name: form.name,
  //       desc: form.desc,
  //       status: form.status,
  //       created_by:pageparmission?._id

  //     };
  //     const res = await axiosConfig.post("/categories/save-category", data);

  //     swal("Success", "Category Added Successfully", "success");

  //     // 👉 redirect
  //     navigate("/production?view=category-subcategory-units");

  //   } catch (err) {
  //     console.error(err);
  //     console.log("FULL ERROR 👉", err);
  //     console.log("BACKEND ERROR 👉", err?.response?.data);
  //     swal("Error", "Something went wrong", "error");
  //   }
  // };
const submitHandler = async (e) => {
  e.preventDefault();

  try {
    const pageparmission = JSON.parse(
      localStorage.getItem("userData")
    );

    const data = {
      name: form.name,
      desc: form.desc,
      status: form.status,
      created_by: pageparmission?._id,
    };

    if (isEdit) {
      // UPDATE
      const res = await axiosConfig.put(
        `/categories/update-category/${editData._id}`,
        data
      );

      console.log("UPDATE RESPONSE:", res);

      swal(
        "Success",
        "Category Updated Successfully",
        "success"
      );
    } else {
      // ADD
      const res = await axiosConfig.post(
        "/categories/save-category",
        data
      );

      console.log("SAVE RESPONSE:", res);

      swal(
        "Success",
        "Category Added Successfully",
        "success"
      );
    }

    navigate(
      "/production?view=category-subcategory-units"
    );

  } catch (err) {
    console.error("FULL ERROR:", err);
    console.log(
      "BACKEND ERROR:",
      err?.response?.data
    );

    swal(
      "Error",
      err?.response?.data?.message ||
        "Something went wrong",
      "error"
    );
  }
};
  return (
    <div className="erp-page-grid">
      <Card className="erp-card">
        <CardBody>
          <h2 style={{ marginBottom: "20px" }}>
  {isEdit ? "Edit Category" : "Add Category"}
</h2>

          <form onSubmit={submitHandler}>
            <Row>
              <Col md="6">
                <Label>Category Name</Label>
                <Input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md="6">
                <Label>Description</Label>
                <Input
                  type="textarea"
                  name="desc"
                  value={form.desc}
                  onChange={handleChange}
                />
              </Col>


              <Col md="2" >
                <Label>Status</Label>
                <Input
                  type="select"
                  name="status"
                  value={form.status}
                  onChange={handleChange}
                >
                  <option>Active</option>
                  <option>Deactive</option>
                </Input>
              </Col>




            </Row>

           <Button
  type="submit"
  color="primary"
  style={{ marginTop: "20px" }}
>
  {isEdit ? "Update Category" : "Add Category"}
</Button>

            <Button
              color="secondary"
              style={{ marginTop: "20px", marginLeft: "10px" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
          </form>
        </CardBody>
      </Card>
    </div>
  );
}